import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'

import { InitMaterialModule } from '../material/init-material.module'
import { InitUiModule } from '../ui/init-ui/init-ui.module'
import { TaxCodeSelectorComponent } from './components/tax-code-selector/tax-code-selector.component'
import { TaxCodeLookupDialog } from './dialogs/tax-code-lookup/tax-code-lookup.dialog'

@NgModule({
  declarations: [TaxCodeSelectorComponent, TaxCodeLookupDialog],
  imports: [CommonModule, ReactiveFormsModule, InitUiModule, InitMaterialModule],
  exports: [TaxCodeSelectorComponent],
})
export class TaxCodeModule {}
